export enum DimModelCategory {
  JET_OUTLETS = "JetOutlets",
  VENTILATION_GRILLES = "VentilationGrilles",
  FILTER_DIFFUSERS = "FilterDiffusers",
  SHUT_OFF_DEVICES = "ShutOffDevices",
  SOUND_ATTENUATOR = "SoundAttenuator",
  SOUND_ABSORBER = "SoundAbsorber",
  VOLUMETRIC_FLOW = "VolumetricFlow",
  FIRE_PROTECTION = "FireProtection",
  AIR_WATER_SYSTEMS = "AirWaterSystems"
}
